import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class UsuarioServico extends Servico {
  constructor() {
    super('usuario')
  }

  recuperarTodos(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}`, { params: { name: filtro.nome, ...filtro } })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  total(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/total`, {
        params: { name: filtro.nome, ...filtro },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  trocarSenha(dados) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/${dados.id}/nova-senha`, dados)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default UsuarioServico
